import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userIncidentNotificationMessages = {
  [AutomationEventTypes.IncidentCreated]: {
    subject: 'Incident Created',
    message: `
      Hi Team,

      An incident has been reported regarding the guest's stay at *|RENTAL:NAME|*. Please review the details and take the necessary actions.

      Incident Details:
      Description: *|INCIDENT:DESCRIPTION|*
      `,
  },
  [AutomationEventTypes.IncidentCritical]: {
    subject: 'Incident Marked as Critical',
    message: `
      Hi Team,

      The incident has been marked as critical. Please take the appropriate action and follow up as needed.

      Booking Details:
      Incident Description: *|INCIDENT:DESCRIPTION|*
      `,
  },
  [AutomationEventTypes.IncidentOnHold]: {
    subject: 'Incident Put on Hold',
    message: `
      Hi Team,

      The incident has been put on hold for further review or pending resolution. Please update records accordingly and await further instructions.

      Booking Details:
      Incident Description: *|INCIDENT:DESCRIPTION|*
      `,
  },
  [AutomationEventTypes.IncidentResolved]: {
    subject: 'Incident Resolved',
    message: `
      Hi Team,

      The incident reported during the guest's stay at *|RENTAL:NAME|* has been resolved. Please update the records accordingly.

      Incident Details:
      Description: *|INCIDENT:DESCRIPTION|*
      `,
  },
}

export const guestIncidentNotificationMessages = {
  [AutomationEventTypes.IncidentCreated]: {
    subject: 'Incident Reported – *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We would like to inform you that an incident has been reported regarding your stay at *|RENTAL:NAME|*.

      Incident Details:
      Description: *|INCIDENT:DESCRIPTION|*

      We are currently investigating this matter and will follow up with you shortly. If you have any questions or concerns, please don’t hesitate to contact us at *|RENTAL:PHONE|*.

      Thank you for your understanding.
    `,
  },
  [AutomationEventTypes.IncidentResolved]: {
    subject: 'Incident Resolution – *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We are pleased to inform you that the incident reported during your stay at *|RENTAL:NAME|* has been resolved.

      Incident Details:
      Description: *|INCIDENT:DESCRIPTION|*

      We apologize for any inconvenience this may have caused and appreciate your understanding. If you have any further questions or concerns, please don’t hesitate to contact us at *|RENTAL:PHONE|*.
    `,
  },
}
